import React from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Snackbar,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const PositionedSnackbars = () => {
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const buttons = (
    <React.Fragment>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="text"
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Top-Center
        </Button>
      </Box>
      <Grid container justifyContent="center">
        <Grid item xs={6}>
          <Button
            variant="text"
            onClick={handleClick({ vertical: "top", horizontal: "left" })}
          >
            Top-Left
          </Button>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <Button
            variant="text"
            onClick={handleClick({ vertical: "top", horizontal: "right" })}
          >
            Top-Right
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="text"
            onClick={handleClick({ vertical: "bottom", horizontal: "left" })}
          >
            Bottom-Left
          </Button>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <Button
            variant="text"
            onClick={handleClick({ vertical: "bottom", horizontal: "right" })}
          >
            Bottom-Right
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="text"
          onClick={handleClick({ vertical: "bottom", horizontal: "center" })}
        >
          Bottom-Center
        </Button>
      </Box>
    </React.Fragment>
  );

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Positioned snackbars
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          In wide layouts, snackbars can be left-aligned or center-aligned if
          they are consistently placed on the same spot at the bottom of the
          screen, however there may be circumstances where the placement of the
          snackbar needs to be more flexible. You can control the position of
          the snackbar by specifying the anchorOrigin prop.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              "  const [state, setState] = React.useState({\n" +
              "    open: false,\n" +
              '    vertical: "top",\n' +
              '    horizontal: "center",\n' +
              "  });\n" +
              "  const { vertical, horizontal, open } = state;\n" +
              "\n" +
              "  const handleClick = (newState) => () => {\n" +
              "    setState({ ...newState, open: true });\n" +
              "  };\n" +
              "\n" +
              "  const handleClose = () => {\n" +
              "    setState({ ...state, open: false });\n" +
              "  };\n" +
              "\n" +
              "  const buttons = (\n" +
              "    <React.Fragment>\n" +
              '      <Box sx={{ display: "flex", justifyContent: "center" }}>\n' +
              "        <Button\n" +
              '          variant="text"\n' +
              '          onClick={handleClick({ vertical: "top", horizontal: "center" })}\n' +
              "        >\n" +
              "          Top-Center\n" +
              "        </Button>\n" +
              "      </Box>\n" +
              '      <Grid container justifyContent="center">\n' +
              "        <Grid item xs={6}>\n" +
              "          <Button\n" +
              '            variant="text"\n' +
              '            onClick={handleClick({ vertical: "top", horizontal: "left" })}\n' +
              "          >\n" +
              "            Top-Left\n" +
              "          </Button>\n" +
              "        </Grid>\n" +
              '        <Grid item xs={6} textAlign="right">\n' +
              "          <Button\n" +
              '            variant="text"\n' +
              '            onClick={handleClick({ vertical: "top", horizontal: "right" })}\n' +
              "          >\n" +
              "            Top-Right\n" +
              "          </Button>\n" +
              "        </Grid>\n" +
              "        <Grid item xs={6}>\n" +
              "          <Button\n" +
              '            variant="text"\n' +
              '            onClick={handleClick({ vertical: "bottom", horizontal: "left" })}\n' +
              "          >\n" +
              "            Bottom-Left\n" +
              "          </Button>\n" +
              "        </Grid>\n" +
              '        <Grid item xs={6} textAlign="right">\n' +
              "          <Button\n" +
              '            variant="text"\n' +
              '            onClick={handleClick({ vertical: "bottom", horizontal: "right" })}\n' +
              "          >\n" +
              "            Bottom-Right\n" +
              "          </Button>\n" +
              "        </Grid>\n" +
              "      </Grid>\n" +
              '      <Box sx={{ display: "flex", justifyContent: "center" }}>\n' +
              "        <Button\n" +
              '          variant="text"\n' +
              '          onClick={handleClick({ vertical: "bottom", horizontal: "center" })}\n' +
              "        >\n" +
              "          Bottom-Center\n" +
              "        </Button>\n" +
              "      </Box>\n" +
              "    </React.Fragment>\n" +
              "  );\n" +
              "\n" +
              "  return (\n" +
              "    <Box sx={{ width: 500 }}>\n" +
              "      {buttons}\n" +
              "      <Snackbar\n" +
              "        anchorOrigin={{ vertical, horizontal }}\n" +
              "        open={open}\n" +
              "        onClose={handleClose}\n" +
              '        message="I love snacks"\n' +
              "        key={vertical + horizontal}\n" +
              "      />\n" +
              "    </Box>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <Box sx={{ width: 500 }}>
              {buttons}
              <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={handleClose}
                message="I love snacks"
                key={vertical + horizontal}
              />
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default PositionedSnackbars;
